import { render } from "./FaceIdCreateDrawer.vue?vue&type=template&id=6ffc00be"
import script from "./FaceIdCreateDrawer.vue?vue&type=script&lang=js"
export * from "./FaceIdCreateDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__